interface IProps {
  theme: "light" | "dark";
  onClick?: () => void;
}

export const MessageIcon = ({ theme, onClick }: IProps) => {
  return (
    <div onClick={onClick}>
      <svg
        width="24"
        height="21"
        viewBox="0 0 24 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5214 0.0859375C5.12716 0.0859375 0.0310022 4.66497 0.0310022 10.3187C0.0310022 12.0942 0.559848 13.7763 1.42523 15.2715C1.56946 15.5051 1.61754 15.7855 1.52139 16.0658L0.0310022 20.0374C-0.113229 20.4112 0.271387 20.7383 0.656002 20.6449L4.79062 19.1029C5.031 19.0095 5.31946 19.0562 5.60792 19.1964C7.33869 20.1309 9.406 20.6916 11.6175 20.6916C17.9156 20.6449 23.0598 16.1126 23.0598 10.4121C23.0118 4.66497 17.8675 0.0859375 11.5214 0.0859375ZM5.75216 12.2344C4.69446 12.2344 3.82908 11.3933 3.82908 10.3654C3.82908 9.33745 4.69446 8.49641 5.75216 8.49641C6.80985 8.49641 7.67523 9.33745 7.67523 10.3654C7.67523 11.3933 6.80985 12.2344 5.75216 12.2344ZM11.5214 12.2344C10.4637 12.2344 9.59831 11.3933 9.59831 10.3654C9.59831 9.33745 10.4637 8.49641 11.5214 8.49641C12.5791 8.49641 13.4445 9.33745 13.4445 10.3654C13.4445 11.3933 12.5791 12.2344 11.5214 12.2344ZM17.2906 12.2344C16.2329 12.2344 15.3675 11.3933 15.3675 10.3654C15.3675 9.33745 16.2329 8.49641 17.2906 8.49641C18.3483 8.49641 19.2137 9.33745 19.2137 10.3654C19.2137 11.3933 18.3483 12.2344 17.2906 12.2344Z"
          fill={theme === "dark" ? "white" : "black"}
        />
      </svg>
    </div>
  );
};
